// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__vItTL","showOnMobileOnly":"Hero_showOnMobileOnly__5tq8d","wrapper":"Hero_wrapper__4v6vc","leftColumn":"Hero_leftColumn__qLSpJ"};